module.exports = __webpack_public_path__ + "1c6c1dade648e5a8c1bb0806d13aa6d1.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-12@2x.png
// module id = 502
// module chunks = 0